import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Space,
  Modal,
  message,
  Input,
  Tree,
  Form,
  Tag,
  Typography,
  Radio,
  Select,
} from 'antd';
import useWebPost from '../utils/useWebPost';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ImgUploader from '../components/ImgUploader';
import renderFileList from '../components/renderFileList';
import { roleTree, roles } from '../utils/AdminRole';
import CustModal from '../components/ShowModal';
const { Text } = Typography;
const { Option } = Select;
const buildParentMap = (treeData, parentMap = {}) => {
  treeData.forEach(node => {
    if (node.children) {
      node.children.forEach(child => {
        parentMap[child.key] = node.key;
      });
      buildParentMap(node.children, parentMap);
    }
  });
  return parentMap;
};
const buildChildrenMap = (treeData, childrenMap = {}) => {
  treeData.forEach(node => {
    if (node.children && node.children.length > 0) {
      childrenMap[node.key] = node.children.map(child => child.key);
      buildChildrenMap(node.children, childrenMap);
    }
  });
  return childrenMap;
};
const parentMap = buildParentMap(roleTree);
const childrenMap = buildChildrenMap(roleTree);

const getCheckedKeysWithDependencies = (checkedKeys) => {
  const keys = Array.isArray(checkedKeys)
    ? checkedKeys
    : checkedKeys?.checked || [];
  const keysSet = new Set(keys);

  keys.forEach(key => {
    let current = key;
    while (parentMap[current]) {
      const parent = parentMap[current];
      if (!keysSet.has(parent)) {
        keysSet.add(parent);
        current = parent;
      } else {
        break;
      }
    }
  });

  const toRemove = new Set();
  const shouldRemoveParent = (parentKey) => {
    const children = childrenMap[parentKey];
    if (!children || children.length === 0) return false;

    const hasAnyChildSelected = children.some(child => {
      if (keysSet.has(child)) return true;
      const checkDescendant = (nodeKey) => {
        const subChildren = childrenMap[nodeKey];
        if (!subChildren) return false;
        return subChildren.some(sub => keysSet.has(sub) || checkDescendant(sub));
      };
      return checkDescendant(child);
    });

    return !hasAnyChildSelected;
  };

  keysSet.forEach(key => {
    if (childrenMap[key] && shouldRemoveParent(key)) {
      toRemove.add(key);
    }
  });

  toRemove.forEach(key => keysSet.delete(key));
  const permt = Array.from(keysSet);
  return permt;
};

function AdminList1() {
  const webPost = useWebPost(); // 直接使用你的钩子
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({ phone: '' });
  const [modalVisible, setModalVisible] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [ptype, setPtype] = useState('1');
  const [roletype, setRoletype] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchAdminList(1, pageSize, filters);
    fetchRoletype();
  }, []);

  const fetchRoletype = async () => {
    const ds = await webPost("getCustroles");
    if (ds) {
      setRoletype(ds);
    }
  }
  const fetchAdminList = async (page = 1, pageSize = 10, filters = {}) => {
    setLoading(true);
    try {
      const response = await webPost('adminList', { page, limit: pageSize, type: 1, ...filters });
      if (response && response.data) {
        setData(response.data);
        setTotal(response.total);
      }
    } catch (error) {
      console.error('获取用户列表失败:', error);
      message.error('请求失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const openModal = (employee = { id: 0, name: '', phone: '',  stp: '1' }) => {
    setModalVisible(true);
    form.resetFields();
    setCurrentEmployee(employee);
    const permission = Array.isArray(employee.permission)
      ? employee.permission
      : typeof employee.permission === 'string'
        ? employee.permission.split(',')
        : [];

    form.setFieldsValue({
      ...employee,
      permission,

    });
    setPtype(employee?.stp ? String(employee?.stp): "1");
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: '确认删除用户',
      content: '删除后无法恢复，确定要删除吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        try {
          const response = await webPost('adminDel', { id });
          if (response) {
            message.success('删除成功');
            fetchAdminList(currentPage, pageSize, filters);
          }
        } catch (error) {
          message.error('请求失败，请稍后重试');
        }
      },
    });
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };
  const resetPasswordApi = async (userId) => {
    const ret = await webPost(`repassword`, { id: userId });
    if (ret) {
      Modal.success({
        title: '操作成功',
        content: '密码已重置为默认密码8888',
      });
    }
  }
  const handleClearFilters = () => {
    const clearFilters = { name: '', phone: '' };
    setFilters(clearFilters);
    setCurrentPage(1);
    fetchAdminList(1, pageSize, clearFilters);
  };

  // 动态计算表格最大高度（确保分页和表头不滚动）
  const tableHeight = window.innerHeight - 240; // 可根据 header/footer 调整

  const columns = [
    { title: '登录手机', dataIndex: 'phone', key: 'phone', width: 150 },
    { title: '姓名', dataIndex: 'name', key: 'name', width: 120 },
    { title: '紧急联系人', dataIndex: 'lxr', key: 'lxr', width: 120, },
    { title: '身份证', dataIndex: 'sfz', key: 'sfz', width: 120, render: (_) => renderFileList(_) },
    { title: '协议附件', dataIndex: 'xy', key: 'xy', width: 120, render: (_) => renderFileList(_) },
    { title: '其它说明', dataIndex: 'ps', key: 'ps', width: 120, },
    {
      title: '权限',
      dataIndex: 'permission',
      key: 'permission',
      width: 460,
      render: (_, record) => {
        const p = record?.permission;
        if (!p) return <Text type="secondary">未获得任何权限</Text>;
        const ds = typeof p === 'string' ? p.split(',') : p;
        if (ds.includes('all')) {
          return <Tag color="blue">管理员</Tag>;
        }
        const permissionTags = ds
          .map((perm) => {
            const label = roles[perm];
            return label ? <Tag key={perm}>{label}</Tag> : null;
          })
          .filter(Boolean);
        return <Space size="small" wrap>{permissionTags}</Space>;
      },
    },
    {
      title: '最后登录',
      dataIndex: 'lastlogin',
      key: 'lastlogin', width: 180
    },
    {
      title: '操作',
      key: 'action',
      width: 200,
      render: (_, record) => (
        <Space size="middle">
          <Button size="small" type="link" onClick={() => openModal(record)}>
            编辑
          </Button>
          <Button size="small" danger type="link" onClick={() => handleDelete(record.id)}>
            删除
          </Button>
          <Button
            size="small"
            type="link"
            onClick={() => {
              Modal.confirm({
                title: '确认重置密码？',
                icon: <ExclamationCircleOutlined />,
                content: `确定要重置用户【${record.name}】的密码吗？此操作不可撤销。`,
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk: async () => {
                  resetPasswordApi(record.id);
                },
              });
            }}
          >
            重置密码
          </Button>
        </Space>
      ),
    },
  ];
  const submitForm = async () => {
    const values = await form.validateFields();
    try {
      const params = { id: currentEmployee?.id || 0, type: 1, ...values}
      if(values.stp ==='1'){
        const pm = roletype.filter((it)=> {return Number(it.id) === Number(values.js_id)});
        if(pm.length<1){
          message.error("请选择角色");
          return;
        }
        params.permission = pm[0].permission;
      }else{
        params.permission = values.permission.join(',');
      }
      const response = await webPost('adminSave', params);
      if (response) {
        message.success(`${currentEmployee.id > 0 ? '更新' : '添加'}成功`);
        setModalVisible(false);
        fetchAdminList(currentPage, pageSize, filters);
      }
    } catch {
      message.error(`${currentEmployee.id > 0 ? '更新' : '添加'}失败`);
    }

  }

  return (
    <div style={{ padding: '16px', background: '#fff', borderRadius: '8px' }}>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>用户列表</h2>
        <Button type="primary" onClick={() => openModal()}>
          添加用户
        </Button>
      </div>

      <div style={{ marginBottom: '16px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <Input
          placeholder="姓名、手机号"
          value={filters.name}
          onChange={(e) => handleFilterChange('name', e.target.value)}
          style={{ width: 200 }}
        />
        <Space>
          <Button type="primary" onClick={() => fetchAdminList(1, pageSize, filters)}>
            搜索
          </Button>
          <Button onClick={handleClearFilters}>清空</Button>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize,
          total,
          showSizeChanger: true,
          showQuickJumper: true,
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
            fetchAdminList(page, size, filters);
          },
        }}
        scroll={{ x: 'max-content', y: Math.max(tableHeight, 200) }} // 至少 200px 高度
        style={{ marginTop: '8px' }}
      />

      {/* 添加/编辑用户模态框 */}
      <CustModal
        title={currentEmployee?.id > 0 ? '编辑用户' : '添加用户'}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        width={720}
        onOk={submitForm}
      >
        <Form form={form} labelCol={{span:4}}>
          <Form.Item
            label="登录手机号"
            name="phone"
            rules={[{ required: true, message: '请输入手机号，用于登录' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="姓名"
            name="name"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="紧急联系人"
            name="lxr"
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="身份证"
            name="sfz"
          >
            <ImgUploader />
          </Form.Item>
          <Form.Item
            label="协议附件"
            name="xy"
          >
            <ImgUploader />
          </Form.Item>
          <Form.Item
            label="其它说明"
            name="ps"
          >
            <Input placeholder='最多200字' />
          </Form.Item>
          <Form.Item label="权限类型" name="stp"><Radio.Group onChange={(e) => { setPtype(e.target.value); console.log(e) }}><Radio value='1'>使用角色</Radio><Radio value='2'>自定义</Radio></Radio.Group></Form.Item>
          {ptype === '1' && (
            <Form.Item label="选择角色" name="js_id">
              <Select><Option value={'0'}>--请选择--</Option>{roletype.map(it => (<Option key={`js_${it.id}`} value={String(it.id)}>{it.name}</Option>))}</Select>
            </Form.Item>
          )}
          {ptype === '2' && (
            <div style={{ maxHeight: 300, overflow: 'auto' }}>
              <Form.Item
                label="权限"
                name="permission"
                valuePropName="checkedKeys"
                trigger="onCheck"
                rules={[{ required: true, message: '请选择至少一个权限' }]}
                getValueProps={(value = []) => ({
                  checkedKeys: Array.isArray(value) ? value : [],
                })}
                getValueFromEvent={(checkedKeys) => {
                  const newkeys = getCheckedKeysWithDependencies(checkedKeys);
                  console.log(checkedKeys, newkeys);
                  return newkeys;
                }}
              >
                <Tree checkable treeData={roleTree} checkStrictly={true} />
              </Form.Item>
            </div>

          )}

        </Form>
      </CustModal>
    </div>
  );
}

export default AdminList1;